<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>Refunds </h2>
                </div>
                <div class="col-md-2 col2 "> <a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id='31'>
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe
                            class="i-frame"
                            src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div> -->
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="32">
                    <label for="" class="mt-3">Refunds are a part of the payment
                        process that allows
                        you
                        to
                        return funds(money) to a customer who has previously made a purchase.
                        They're
                        essential
                        for maintaining customer satisfaction and managing your business's financial
                        transactions. A refund is a process through which you return a portion or
                        the
                        entirety
                        of a customer's payment for a product or service. This could be due to
                        various
                        reasons,
                        such as product returns, cancellations, or resolving customer complaints.
                    </label>

                </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="33">
                    <h2>
                        Key Elements of Refunds:
                    </h2>

                    <ul>
                        <li class="mt-3"><b>Initiation: </b>&nbsp;Refunds are initiated by the
                            merchant
                            when
                            a
                            customer requests to return a product, cancels an order, or encounters
                            an
                            issue
                            that
                            warrants a refund. </li>

                        <li class="mt-3"><b>Processing: </b>&nbsp;Once a refund is requested, you
                            can
                            initiate
                            the refund process through PayG. PayG communicates with the respective
                            financial
                            institutions involved to transfer the refunded amount back to the
                            customer's
                            account. </li>

                        <li class="mt-3"><b>Timeline: </b>&nbsp;The timeline for processing refunds
                            can
                            vary
                            depending on the payment method used by the customer and the policies of
                            the
                            banks
                            involved. Credit card refunds, for instance, might take a few business
                            days
                            to
                            reflect in the customer's account. </li>

                        <li class="mt-3"><b>Communication: </b>&nbsp;It's crucial to keep the
                            customer
                            informed
                            about the refund process. Provide them with confirmation of the refund
                            initiation
                            and an estimated timeline for when they can expect to see the funds
                            returned.
                        </li>
                    </ul>


                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                    id="34">
                    <h2>Importance of Refunds: </h2>

                    <ul>
                        <li class="mt-3"><b>Customer Satisfaction: </b>&nbsp;Refunds play a
                            significant
                            role
                            in
                            maintaining customer satisfaction. If a customer isn't happy with their
                            purchase,
                            being able to offer a hassle-free refund can leave a positive
                            impression.
                        </li>

                        <li class="mt-3"><b>Trust Building: </b>&nbsp;Just like reliable
                            transactions,
                            hassle-free refunds contribute to building trust between you and your
                            customers.
                            This trust can lead to repeat business and positive word-of-mouth. </li>

                        <li class="mt-3"><b>Conflict Resolution: </b>&nbsp; Refunds also serve to
                            resolve
                            issues. If a customer receives a damaged or incorrect product, offering
                            a
                            prompt
                            refund can turn a potentially negative experience into a positive one.
                        </li>
                    </ul>

                </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')"
                    id="35">
                    <h2>Using PayG Refunds: </h2>

                    <label for="" class="mt-3">With PayG, you can manage refunds
                        efficiently through
                        the
                        merchant portal. Initiate refunds, track their progress, and communicate
                        directly
                        with
                        customers about the refund status. </label>
                    <label for="" class="mt-3">In summary, refunds are an integral
                        part of the
                        customer-business
                        relationship. By understanding and effectively managing refunds, you can
                        enhance
                        customer satisfaction, build trust, and ensure smooth interactions with your
                        customers.
                        PayG is here to assist you in making the refund process as seamless as
                        possible.
                    </label>

                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4 hide-tbl content2  ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>

                </div>

                <!-- <div class="col-md-12 mt-2">
                    <a href="#31"> <div class="row">
                        <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                alt=""> &nbsp;</div>
                        <div class="col-md-10"><span style="cursor: pointer;" class="videoHover"
                                [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                Introduction to Refunds </span>
                        </div>
                    </div></a>
                </div> -->
                <div class="col-md-12 mt-2"> 
                    <a href="#32">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10"><span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='2'}" (click)="color('2')">
                                    Introduction to Refunds </span>

                            </div>

                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#33">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">Key
                                    Elements of Refunds
                                </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#34">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">
                                    Importance of Refunds </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#35">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" [ngClass]="{'color':colors=='5'}"
                                    (click)="color('5')">PayG Refunds </span>

                            </div>
                        </div>
                    </a>
                </div>


            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                <a [routerLink]="['/transaction']">     <button class="btn btn-color" (click)="menues('Transactions')" > <img
                        src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Transactions
                </button></a>
               
            </div>
            <div class="col-md-4    ">
                <a [routerLink]="['/disputes']"> <button class="btn btn-color" (click)="menues('Disputes')" >Disputes
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
                
            </div>
        </div>
    </div>
</div>